import { render, staticRenderFns } from "./ClinicMain.vue?vue&type=template&id=5cc0c91f&"
import script from "./ClinicMain.vue?vue&type=script&lang=js&"
export * from "./ClinicMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports